export const copyToClipboard = async (text: string) => {
    try {
        await navigator.clipboard.writeText(text);
    } catch (e) {
        console.error("Failed to copy:", e);
    }
};